<template>
  <div class="personnelMange">
    <div class="panel_head">
      <span>|&nbsp;員工資料</span>
    </div>
    <div class="com_box">
      <div class="com_head">
        <template v-if="false">
          <span style="margin-right: .12rem;font-size: .16rem;color: #666;">查詢方式</span>
          <el-radio v-model="queryType" :label="1">公司賬號</el-radio>
          <el-radio v-model="queryType" :label="2" style="margin-right: 0.25rem;">員工ID</el-radio>
        </template>
        <template v-if="queryType===1">
          <span style="margin-right: .12rem;font-size: .16rem;color: #666;">公司賬號</span>
          <el-input
            class="idBox"
            placeholder="請輸入公司賬號"
            v-model="companyCode"
            style="width: 2.50rem;"
            clearable>
          </el-input>
        </template>
        <template v-if="queryType===2">
          <span style="margin-left: .30rem;margin-right: .12rem;font-size: .16rem;color: #666;">(公眾號)會員ID</span>
          <el-input
            class="idBox"
            placeholder="請輸入(公眾號)會員ID"
            v-model="memberId"
            style="width: 2.50rem;"
            clearable>
          </el-input>
        </template>
        <!--搜索框-->
        <!--<div class="searchInput" v-show="reportType=='1'&&orderList.length!=0">
            <el-input
                placeholder="請輸入搜索條件"
                v-model="search_index"
                style="width: 2.00rem;"
                clearable>
            </el-input>
        </div>
        <div class="searchInfoInput" v-show="reportType=='2'&&orderInfoList.length!=0">
            <el-input
                placeholder="請輸入搜索條件"
                v-model="search_info_index"
                style="width: 2.00rem;"
                clearable>
            </el-input>
        </div>-->

        <!--        <div class="import_btn none" @click="importExcel">導入員工信息EXCEL</div>-->

        <el-upload
          class="upload_btn"
          name="files"
          :headers="{'Authorization':$store.state.token}"
          :action="uploadUrl"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="importExcelFinish"
          :before-remove="beforeRemove"
          :multiple="false"
          :limit="1"
          :on-exceed="handleExceed"
          :with-credentials="true"
          :show-file-list="false"
          :file-list="fileList"
          :data="{companyCode:$store.state.userInfo.company_code}">
          <el-button size="small" type="primary" class="import_btn">導入員工信息EXCEL</el-button>
          <div slot="tip" class="tip">
            <!--            只能上傳excel文件，且不超過500kb-->
            <!--            <br>-->
            每次導入員工數據不要超過1000條
          </div>
        </el-upload>

        <div class="add_btn" @click="dialogsStatus='new';dialogShowHideEvent()">新增</div>

        <div class="query_btn" @click="queryForm">立即查詢</div>

      </div>
      <div class="tableBox" ref="tableBox">
        <table id="excelTable">
          <!--正常表頭-->
          <thead ref="tableFixedHead">
          <tr>
            <th>公司</th>
            <th>姓名</th>
            <th>性別</th>
            <th>合約編號</th>
            <th>合約有效期</th>
            <th>職工證編號</th>
            <th>身份證</th>
            <th>(公眾號)會員ID</th>
            <th>狀態</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody v-if="showUserInfoArr.length>0">
          <tr v-for="u in showUserInfoArr">
            <td>{{ u.company_name_ch }}</td>
            <td>{{ u.user_name }}</td>
            <td>{{ u.user_sex === 'M' ? '男' : '女' }}</td>
            <td>{{ u.contracts_code }}</td>
            <td>{{ formatTimesteampToStr(u.contracts_expiration_date) }}</td>
            <td>{{ u.user_work_cardid }}</td>
            <td>{{ u.user_cardid }}</td>
            <td>{{ u.member_id }}</td>
<!--            <td>{{ u.personnel_ercode }}</td>-->
            <td>{{ u.status === '1' ? '正常' : '停用' }}</td>
            <td>
              <span class="editBtn"
                    @click="dialogsStatus='edit';setSelectedUserInfo(u);dialogShowHideEvent()">修改</span>
              <span class="delBtn" @click="delUserEvent(u)">刪除</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="page_box" v-show="userInfoArr.length>10">
        <div class="block">
          <el-pagination
            layout="prev, pager, next"
            @current-change="pageChange"
            :current-page="currentPage"
            :total="userInfoArr.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <dialogs
      v-if="isShowDialog"
      :user-info="selectedUserInfo"
      :dialogs-status="dialogsStatus"
      @closeDialog="dialogShowHideEvent(false)"
      @confirmEvent="dialogConfirmEvent"/>
  </div>
</template>
<script>
import dialogs from "./dialogs.vue";

export default {
  data()
  {
    return {
      //公司賬號
      companyCode: "",
      //用戶賬號
      memberId: "",
      //查詢方式
      queryType: 2,
      //員工信息列表
      userInfoArr: [],
      //顯示的員工信息
      showUserInfoArr: [],
      //分批的數據
      batchUserInfo: {},
      //當前頁碼
      currentPage: 1,
      //頁面顯示行數
      pageSize: 10,
      //總頁數
      pageCount: 0,
      //上傳文件列表
      fileList: [],
      //上傳請求地址
      uploadUrl: this.IP + this.PATH + "/personne/personnel.user.insert.import",
      //當前用戶公司賬號
      currentCompanyCode: "",
      //彈出層的狀態 new edit
      dialogsStatus: 'new',
      //是否顯示對話框
      isShowDialog: false,
      //選中的用戶信息
      selectedUserInfo: {},
    }
  },
  async created()
  {
    //請求用戶數據
    await this.queryUserInfo()
  },
  methods: {
    //時間戳轉字符串
    formatTimesteampToStr(timestamp)
    {
      //只顯示日期部份
      return new Date(timestamp).toLocaleString().split(" ")[0]
    },
    //導入員工信息
    async importExcelFinish(response, fileList)
    {
      console.log(response, fileList);

      //清空
      this.fileList = []

      //上傳接口不成功
      if(response.code !== 'SUCCESS')
      {
        let apiErrmsg = ""
        if(response.responseData.ret !== 0)
        {
          apiErrmsg = response.responseData.errmsg
        }

        this.$message.warning(response.message + " " + apiErrmsg);
        return
      }

      //上傳後臺不成功
      if(response.responseData.ret !== 0)
      {
        this.$message.warning(response.responseData.errmsg);
        return
      }

      this.$message.success('導入成功');

      //刷新員工
      await this.queryForm()

    },
    async queryForm()
    {
      await this.queryUserInfo()
    },
    pageChange(pageNo)
    {
      this.showUserInfoArr = this.batchUserInfo[pageNo]
      this.$forceUpdate()
    },
    //請求用戶數據
    async queryUserInfo()
    {
      //初始化
      this.showUserInfoArr = []
      this.batchUserInfo = {}
      this.userInfoArr = []

      //如果公司賬號
      if(this.queryType === 1 && this.companyCode)
      {
        //查詢用戶數據
        let res = await this.axios.post(this.IP + this.PATH + '/personne/personnel.user.lists', {
          companyCode: this.companyCode
        })
        //賦值
        this.userInfoArr = res.data.responseData

      }
      //如果有用戶ID
      else if(this.queryType === 2 && this.memberId)
      {
        //查詢用戶數據
        let res = await this.axios.post(this.IP + this.PATH + '/personne/personnel.user.query', {
          memberId: this.memberId
        })
        //賦值
        this.userInfoArr = res.data.responseData ? [res.data.responseData] : []

      }
      else
      {
        //當前公司編碼
        let companyCode = this.$store.state.userInfo.company_code
        //查詢用戶數據
        let res = await this.axios.post(this.IP + this.PATH + '/personne/personnel.user.lists', {
          companyCode
        })
        //賦值
        this.userInfoArr = res.data.responseData
      }

      //沒數據返回
      if(this.userInfoArr.length <= 0)
      {
        return
      }

      // this.userInfoArr.push(...this.userInfoArr)
      // this.userInfoArr.push(...this.userInfoArr)
      // this.userInfoArr.push(...this.userInfoArr)

      //總共頁數
      this.pageCount = Math.ceil(this.userInfoArr.length / this.pageSize)

      //當前頁號
      let pageNo = 1
      //分批數據
      for(let i = 0; i < this.userInfoArr.length; i++)
      {
        if(i > this.pageSize * pageNo - 1)
        {
          pageNo += 1
        }

        if(this.batchUserInfo[pageNo])
        {
          this.batchUserInfo[pageNo].push(this.userInfoArr[i])
        }
        else
        {
          this.batchUserInfo[pageNo] = [this.userInfoArr[i]]
        }
      }

      this.showUserInfoArr = this.batchUserInfo[this.currentPage]

      //刷新界面
      this.$forceUpdate()

    },
    //刪除用戶
    async delUserEvent(userInfo)
    {
      // console.log(userInfo);
      await this.$confirm(`要刪除" ${userInfo.user_name} "用戶嗎?`, '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      })

      //當前公司編碼
      let companyCode = this.$store.state.userInfo.company_code

      //請求接口
      let res = await this.axios.post(this.IP + this.PATH + '/personne/personnel.user.del', {
        memberId: userInfo.member_id,
        companyCode
      })

      //返回如果
      let data = res.data

      //如果接口不成功
      if(data.code !== 'SUCCESS')
      {
        this.$message.warning(data.message);
        return
      }
      //如果後臺不成功
      if(data.responseData.ret !== 0)
      {
        this.$message.warning(data.responseData.errmsg);
        return
      }
      //提示
      this.$notify({title: '成功', message: '刪除成功', type: 'success'});
      //刷新數據
      await this.queryUserInfo()
      this.isShowDialog = false

    },
    //對話框顯隱事件
    dialogShowHideEvent(status = true)
    {
      this.isShowDialog = status
    },
    //對話框提交事件
    async dialogConfirmEvent(userInfo)
    {
      //當前公司編碼
      let companyCode = this.$store.state.userInfo.company_code

      switch(this.dialogsStatus)
      {
        //新增用戶操作
        case "new":
          //查詢用戶數據
          let res = await this.axios.post(this.IP + this.PATH + '/personne/personnel.user.insert',
            {
              ...userInfo,
              companyCode
            })
          //返回如果
          let data = res.data

          //如果接口不成功
          if(data.code !== 'SUCCESS')
          {
            this.$message.warning(data.message);
            return
          }
          //如果後臺不成功
          if(data.responseData.ret !== 0)
          {
            this.$message.warning(data.responseData.errmsg);
            return
          }
          //提示
          this.$notify({title: '成功', message: '添加成功', type: 'success'});
          //刷新數據
          await this.queryUserInfo()
          this.isShowDialog = false

          break
        //編輯用戶操作
        case 'edit':
          //查詢用戶數據
          let res2 = await this.axios.post(this.IP + this.PATH + '/personne/personnel.user.update',
            {
              ...userInfo,
              companyCode
            })
          //返回如果
          let data2 = res2.data

          //如果接口不成功
          if(data2.code !== 'SUCCESS')
          {
            this.$message.warning(data2.message);
            return
          }
          //如果後臺不成功
          if(data2.responseData.ret !== 0)
          {
            this.$message.warning(data2.responseData.errmsg);
            return
          }
          //提示
          this.$notify({title: '成功', message: '編輯成功', type: 'success'});
          //刷新數據
          await this.queryUserInfo()
          this.isShowDialog = false

          break
      }
    },
    //設置選中的用戶信息
    setSelectedUserInfo(userInfo)
    {
      this.selectedUserInfo = {}

      Object.keys(userInfo).map(k => {
        if(k === 'contracts_expiration_date')
        {
          this.selectedUserInfo[this.underlineToHump(k)] = this.getDatetime(userInfo[k]).dateTime
          return
        }
        this.selectedUserInfo[this.underlineToHump(k)] = userInfo[k]
      })
    },
    handleRemove(file, fileList)
    {
      console.log(file, fileList);
    },
    handlePreview(file)
    {
      console.log(file);
    },
    handleExceed(files, fileList)
    {
      this.$message.warning(`當前限制選擇 3 個文件，本次選擇了 ${files.length} 個文件，共選擇了 ${files.length + fileList.length} 個文件`);
    },
    beforeRemove(file, fileList)
    {
      return this.$confirm(`確定移除 ${file.name}？`);
    }
  },
  components: {dialogs},
}
</script>
<style lang="less">
.personnelMange {
  .panel_head {
    margin: .1rem 0;
  }

  .panel_head:after {
    content: '';
    display: block;
    overflow: hidden;
    clear: both;
  }

  .panel_head > span {
    float: left;
    margin-left: .83rem;
    font-size: .24rem;
  }

  .panel_head > div {
    width: .85rem;
    height: .30rem;
    line-height: .30rem;
    text-align: center;
    background-color: transparent;
    color: #000;
    display: inline-block;
    cursor: pointer;
    margin-left: .15rem;
    margin-top: .03rem;
  }

  .panel_head > div.active {
    background-color: #1e7feb;
    color: #fff;
  }

  .com_box {
    padding: 0 2% .5rem 2%;
    background-color: #fff;
    background-clip: content-box;
    min-height: 7rem;
    //margin-bottom: .30rem;
    position: relative;
  }

  .com_box::-webkit-scrollbar {
    display: none;
  }

  .com_box .com_head {
    padding-left: .60rem;
    padding-top: .20rem;
    padding-bottom: .20rem;
  }

  /*重寫搜索欄組件樣式*/

  .com_box .com_head .payTypeBox /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .payTypeBox /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .com_head .idBox /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .idBox /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .com_head .sumDateBox {
    width: 3.5rem;
    height: .4rem;
    padding: 0.03rem 0.1rem;
  }

  .com_box .com_head .sumDateBox /deep/ .el-range__icon {
    line-height: .32rem;
  }

  .com_box .com_head .sumDateBox /deep/ .el-range-separator {
    padding: 0 0.05rem;
    line-height: .32rem;
    font-size: .14rem;
    width: 8%;
  }

  .com_box .com_head .sumDateBox /deep/ .el-range-input {
    font-size: .14rem;
  }

  .com_box .com_head .detailDateBox {
    width: 3.8rem;
    height: .4rem;
    padding: 0.03rem 0.1rem;
  }

  .com_box .com_head .detailDateBox /deep/ .el-range__icon {
    line-height: .32rem;
  }

  .com_box .com_head .detailDateBox /deep/ .el-range-separator {
    padding: 0 0.05rem;
    line-height: .32rem;
    font-size: .14rem;
    width: 8%;
  }

  .com_box .com_head .detailDateBox /deep/ .el-range-input {
    font-size: .14rem;
  }

  .com_box .com_head .chargeNoBox /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .com_head .chargeNoBox /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .query_btn {
    display: inline-block;
    border-radius: 3px;
    background-color: #e29a33;
    margin-top: .05rem;
    float: right;
    color: #fff;
    cursor: pointer;
    width: 1.5rem;
    height: .40rem;
    font-size: .18rem;
    line-height: .40rem;
    text-align: center;
    margin-left: .30rem;
    vertical-align: middle;
    margin-right: .5rem;
    font-weight: normal;
  }

  .com_box .com_head .add_btn {
    display: inline-block;
    border-radius: 3px;
    background-color: #3d61b1;
    margin-top: .05rem;
    float: right;
    color: #fff;
    cursor: pointer;
    width: 1.00rem;
    height: .40rem;
    font-size: .18rem;
    line-height: .40rem;
    text-align: center;
    margin-left: .30rem;
    vertical-align: middle;
    margin-right: .2rem;
    font-weight: normal;
  }

  .com_box .com_head .check_btn.active {
    position: absolute;
    top: -.50rem;
    right: 1.50rem;
  }

  .com_box .com_head .searchInput {
    position: absolute;
    top: -.6rem;
    right: .66rem;
  }

  .com_box .com_head .searchInput /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .searchInput /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .com_head .searchInfoInput {
    position: absolute;
    top: -.6rem;
    right: 3rem;
  }

  .com_box .com_head .searchInfoInput /deep/ .el-input__icon {
    font-size: .14rem;
    line-height: .4rem;
  }

  .com_box .com_head .searchInfoInput /deep/ .el-input__inner {
    width: 2rem;
    height: .4rem;
    font-size: .14rem;
  }

  .com_box .upload_btn {
    display: inline-block;
    float: right;
    margin-right: .1rem;

    .tip {
      color: #f0435b;
    }
  }

  .com_box .com_head .import_btn {
    margin-right: .30rem;
    display: inline-block;
    background-color: #30976d;
    border: none;
    float: right;
    color: #fff;
    cursor: pointer;
    height: .40rem;
    font-size: .18rem;
    line-height: .40rem;
    text-align: center;
    vertical-align: middle;
    font-weight: normal;
    padding: 0 .2rem;
    margin-top: .05rem;
  }

  .com_box .com_head .export_btn.active {
    position: absolute;
    top: -.50rem;
    right: .20rem;
  }

  .com_box .tableBox {
    width: 100%;
    height: 6rem;
    overflow: hidden;
  }

  .com_box .tableBox table {
    width: 100%;
    box-sizing: border-box;
    border-spacing: 0;
  }

  .com_box .tableBox table thead {
    background-color: #2b5787;
    color: #fff;
  }

  .tableBox {
    tbody {
      tr {
        &:hover {
          background-color: rgb(225, 225, 225) !important;
        }

        th {
          text-align: center;
        }

        td {
          text-align: center;
          border-bottom: solid 1px #ccc;

          .editBtn {
            cursor: pointer;
            padding: 0 .05rem;
            color: #35bc45;
            //border-bottom: solid 1px #35bc45;
            //padding-bottom: .03rem;
          }

          .delBtn {
            cursor: pointer;
            color: #f0435b;
            padding-right: .05rem;
            text-underline: #f0435b;
            //border-bottom: solid 1px #f0435b;
            //padding-bottom: .03rem;
          }
        }
      }
    }
  }

  /*固定表頭*/

  .com_box .fixHeadBox {
    width: 100%;
    padding: 0 2.5%;
    position: absolute;
    top: 0.8rem;
    left: 0;
  }

  .com_box .fixHead {
    background-color: #2b5787;
    background-clip: content-box;
    color: #fff;
    width: 100%;
    padding-right: .17rem;
  }

  .com_box .fixHead tr th {
    height: .50rem;
    line-height: .5rem;
    //text-align: left;
  }

  /*正常表格*/

  .com_box .tableBox table thead tr th {
    height: .50rem;
    //text-align: left;
  }

  .com_box .tableBox table thead tr th:first-of-type {
    //padding-left: .50rem;
  }

  .com_box .tableBox table thead tr th:last-of-type {
    //padding-right: .30rem;
  }

  .com_box .tableBox table tbody tr td:first-of-type {
    //padding-left: .50rem;
  }

  .com_box .tableBox table tbody tr td:last-of-type {
    //padding-right: .30rem;
  }

  .com_box .tableBox table tbody tr {
    height: .55rem;
    font-size: .18rem;
    text-align: left;
  }

  .com_box .tableBox table tbody tr:nth-of-type(2n) {
    background-color: #fbfbfb;
  }

  .com_box .tableBox .money {
    font-size: .28rem;
  }

  .com_box .tableBox .money span {
    font-size: .18rem;
  }

  .com_box .page_box {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: .1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personnel_manage/index.vue